<template>
  <main class="w-full flex-1 min-w-0 overflow-y-auto overflow-x-auto">
    <slot></slot>
  </main>
</template>
